export default "__VITE_ASSET__BKIED58c__"